module.exports = __webpack_public_path__ + "media/images/landing/partner_logos/farfetch-1029aa4d8c94240c25655380cb76e72f.png";